import get from "lodash.get";
import AbstractApiUtils from "services/cores/abstractApiUtils";

class ReportsUtils extends AbstractApiUtils {
  formatListFromApi = (list) => {
    return {
      items: list.rows,
      length: list.nb_total_items,
    };
  };

  getFilters = (type = "default", reportsStateList) => {
    return {
      frequency: reportsStateList.frequency,
      page: reportsStateList.page + 1,
      nb_items_per_page: reportsStateList.rowsPerPage,
    };
  };

  getSelectedReport = (reportsState) => {
    const selectedWeeklyIndex = get(
      reportsState,
      "weeklyList.selectedIndex",
      null
    );
    const selectedMonthlyIndex = get(
      reportsState,
      "monthlyList.selectedIndex",
      null
    );

    if (selectedWeeklyIndex !== null && selectedWeeklyIndex !== undefined) {
      return get(
        reportsState,
        `weeklyList.items[${selectedWeeklyIndex}]`,
        null
      );
    }
    if (selectedMonthlyIndex !== null && selectedMonthlyIndex !== undefined) {
      return get(
        reportsState,
        `monthlyList.items[${selectedMonthlyIndex}]`,
        null
      );
    }

    return null;
  };
}

export default new ReportsUtils();
